import React, { useState, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { fetchProducts4manual } from '../utils/api';
// For barcode generation, you can use 'react-barcode' or 'qrcode.react' for QR codes.
// Example for barcode (Code128, EAN, etc.):
import Barcode from 'react-barcode';
// Example for QR code (already imported above):
// import { QRCodeCanvas } from 'qrcode.react';
import { Product } from '../utils/types';
import { fetchUsers4manual } from '../utils/api';
import { User } from '../utils/types';
import { fetchProductByUUId } from '../utils/api'; // Assuming you have an API utility function to fetch product details
import { useSelectableData } from '../hooks/useSelectableList';
import { fetchUserByUUId } from '../utils/api'; // Assuming you have an API utility function to fetch user details
import { QrDecodedData, } from '../utils/types'; // Assuming you have a type for decoded QR data


interface QrGenerationProps {
    text: string;
    size?: number;
    title?: string;
}

const fetchItems = async (type: string) => {
    if (type === "item") {
        const res = await fetchProducts4manual(1, '', null, null, 100, 'updated_at DESC');
        return res.products;
    } else {
        const res = await fetchUsers4manual(1, '', 100, 'updated_at DESC');
        return res.users;
    }
};

const QrGeneration: React.FC<QrGenerationProps> = () => {

    const [qr, setQr] = useState('');

    const {
        type, setType,
        uuid, setUuid,
        filteredItems,
        searchQuery,
        setSearch,
    } = useSelectableData({ fetchItems });

    
    const qrText = JSON.stringify({
        // action: 'stock_out',
        action: '',
        id: uuid,
        type,
        ts: new Date().toISOString(),
    });

    const sizeL = 250;
    const sizeM = 150;
    const sizeS = 100;
    const title = 'QR Code for ' + type.charAt(0).toUpperCase() + type.slice(1);

    const generateQr = () => {
        const payload = {
            // action: 'stock_out',
            action: '',
            id: uuid,
            type,
            ts: new Date().toISOString(),
        };
        const encoded = btoa(JSON.stringify(payload));
        setQr(encoded);
    };

    const [qrData, setQrData] = useState<any>(null);

    const [product, setProduct] = useState<Product | null>(null);
    const [user, setUser] = useState<User | null>(null); // This state is for displaying the fetched user details


    useEffect(() => {
        // console.log("QR Text:", qrText);
        if (qr) {
            try {
                const decodedData = JSON.parse(qrText) as QrDecodedData;
                if (decodedData.id) { // Only fetch if ID exists
                    if (decodedData.type === 'item') {
                        fetchProductByUUId(decodedData.id).then(setProduct).catch(err => console.error("Failed to fetch product:", err));
                        setUser(null);
                        setQrData(null);
                    }

                    if (decodedData.type === 'user') {
                        fetchUserByUUId(decodedData.id).then(setUser).catch(err => console.error("Failed to fetch user:", err));
                        console.log("Decoded User Data:", decodedData.id);
                        setProduct(null);
                        setQrData(decodedData);
                    }
                } else {
                    setProduct(null);
                    setUser(null);
                    setQrData(null);
                }
            } catch (error) {
                console.error("Failed to parse QR text:", error);
            }

            setQr(''); // Clear QR after processing
            // setQrData(null); // Reset QR data state
            // setProduct(null); // Reset product state
            // setUser(null); // Reset user state
        }
    }, [qr, qrText, setProduct, setUser, setQrData]);


    return (
        <div className="p-1">
            {/* <div className='flex justify-center items-center mb-1'>
                <h2><a href={`${window.APP_CONFIG?.PUBLIC_URL}/qr-scanner`} target="_blank" rel="noopener noreferrer" className="mx-4 underline">QR Scanner</a></h2>
                <h2>QR Generator</h2>
            </div> */}

            <div>
                <div className="flex flex-row justify-center items-center w-1/2 md:w-1/6">
                    {/* <select value={type} onChange={(e) => setType(e.target.value)}> */}
                    {/* <option value="item">Item</option>
                    <option value="user">User</option> */}
                    {/* </select> */}
                    <span className='background-gray-200 p-2 mr-2'>Select Type:</span>
                    <span className='background-gray-200 p-2'><input type="radio" name="type" value="item" checked={type === 'item'} onChange={() => setType('item')} className='mx-2 w-4 h-4' /> Item</span>
                    <span className='background-gray-200 p-2'><input type="radio" name="type" value="user" checked={type === 'user'} onChange={() => setType('user')} className='mx-2 w-4 h-4' /> User</span>

                </div>

                <input
                    value={searchQuery}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search..."
                    className="border p-2 w-full"
                />
                <select value={uuid} onChange={(e) => setUuid(e.target.value)}   className="border p-2 w-full text-base md:w-auto"
>
                    <option value="">Select {type}</option>
                    {filteredItems.map((item) => (
                        <option key={item.product_uuid || item.user_uuid} value={item.product_uuid || item.user_uuid}>
                            {item.product_name || item.name + '< ' + item.email + ' >'}
                        </option>
                    ))}
                </select>


                <button onClick={() => setQr(qrText)} className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'>Generate QR</button>

            </div>




            {qrText && (

                <div className="p-4 pb-16 flex flex-col md:flex-col justify-between items-center">

                    {/* <p className="mt-4 text-sm text-gray-600 break-all max-w-xs text-center">
                        QR Code for: 
                    </p> */}


                    <div className='flex flex-col md:flex-row  justify-center items-start mb-4 border-l-2 p-1'>

                        <div className='flex flex-col justify-center items-center mb-4 border-l-2 p-1 bg-gray-100'>
                            <h3 className='text-sm font-semibold text-center'>{title}<br />{product?.product_name || user?.name}</h3>
                            <QRCodeCanvas value={qrText} size={sizeS} className='p-4' />
                            {(() => {
                                if (qrText !== null) {
                                    const parsed = JSON.parse(qrText);
                                    if (parsed.type === 'item') {
                                        return <p className='mb-2 text-sm text-gray-500'>{uuid}</p>;
                                    }
                                    if (parsed.type === 'user') {
                                        return <p className='mb-2 text-sm text-gray-500'>{user?.name} - {user?.phone}</p>;
                                    }
                                }
                                return null;
                            })()}
                            <p>QRcode {sizeS}px x {sizeS}px</p>
                            {qrText && (
                                <Barcode
                                    value={
                                        (() => {
                                            try {
                                                const parsed = JSON.parse(qrText);
                                                if (parsed.type === 'item') {
                                                    return uuid || '';
                                                }
                                                if (parsed.type === 'user') {
                                                    return user ? `${user.name}-${user.phone}` : '';
                                                }
                                                return '';
                                            } catch {
                                                return '';
                                            }
                                        })()
                                    }
                                    format="CODE128"
                                    width={1}
                                    height={50}
                                    displayValue={true}
                                    fontSize={12}
                                    className="mt-2"
                                />
                            )}
                        </div>
                        <div className='flex flex-col justify-center items-center mb-4 border-l-2 p-1 bg-gray-100'>
                            <h3 className='text-sm font-semibold text-center'>{title}<br />{product?.product_name || user?.name}</h3>
                            <QRCodeCanvas value={qrText} size={sizeM} className='p-4' />
                            {(() => {
                                if (qrText !== null) {
                                    const parsed = JSON.parse(qrText);
                                    if (parsed.type === 'item') {
                                        return <p className='mb-2 text-sm text-gray-500'>{uuid}</p>;
                                    }
                                    if (parsed.type === 'user') {
                                        return <p className='mb-2 text-sm text-gray-500'>{user?.name} - {user?.phone}</p>;
                                    }
                                }
                                return null;
                            })()}

                            <p>QRcode {sizeM}px x {sizeM}px</p>
                            {qrText && (
                                <Barcode
                                    value={
                                        (() => {
                                            try {
                                                const parsed = JSON.parse(qrText);
                                                if (parsed.type === 'item') {
                                                    return uuid || '';
                                                }
                                                if (parsed.type === 'user') {
                                                    return user ? `${user.name}-${user.phone}` : '';
                                                }
                                                return '';
                                            } catch {
                                                return '';
                                            }
                                        })()
                                    }
                                    format="CODE128"
                                    width={1}
                                    height={50}
                                    displayValue={true}
                                    fontSize={12}
                                    className="mt-2"
                                />
                            )}
                        </div>
                        <div className='flex flex-col justify-center items-center mb-4 border-l-2 p-1 bg-gray-100'>
                            <h3 className='text-sm font-semibold text-center'>{title}<br />{product?.product_name || user?.name}</h3>
                            <QRCodeCanvas value={qrText} size={sizeL} className='p-4' />
                            {(() => {
                                if (qrText !== null) {
                                    const parsed = JSON.parse(qrText);
                                    if (parsed.type === 'item') {
                                        return <p className='mb-2 text-sm text-gray-500'>{uuid}</p>;
                                    }
                                    if (parsed.type === 'user') {
                                        return <p className='mb-2 text-sm text-gray-500'>{user?.name} - {user?.phone}</p>;
                                    }
                                }
                                return null;
                            })()}

                            <p>QRcode {sizeL}px x {sizeL}px</p>
                            {qrText && (
                                <Barcode
                                    value={
                                        (() => {
                                            try {
                                                const parsed = JSON.parse(qrText);
                                                if (parsed.type === 'item') {
                                                    return uuid || '';
                                                }
                                                if (parsed.type === 'user') {
                                                    return user ? `${user.name}-${user.phone}` : '';
                                                }
                                                return '';
                                            } catch {
                                                return '';
                                            }
                                        })()
                                    }
                                    format="CODE128"
                                    width={1}
                                    height={50}
                                    displayValue={true}
                                    fontSize={12}
                                    className="mt-2"
                                />
                            )}
                        </div>

                    </div>

                    <div>
                        {product && !qrData && (
                            <div className='flex flex-col md:flex-row justify-between items-center mb-4 border-l-2 p-1 bg-gray-100'>
                                <div>

                                    <h2 className='text-xl font-semibold mb-4 text-green-600'>Product Details</h2>
                                    <p><strong>Product Name:</strong> {product.product_name}</p>
                                    <p><strong>Product Code:</strong> {product.product_code}</p>
                                    <p><strong>Product Value:</strong> {product.product_value}</p>
                                </div>
                                <div>
                                    <img src={product.media?.[0]?.preview_url || product.media?.[0]?.original_url || window.APP_CONFIG?.PUBLIC_URL + '/placeholder.jpg'} alt={product.product_name} />

                                </div>
                            </div>
                        )}

                        {/* // Display user data if available */}
                        {qrData && user && !product && (
                            <div>
                                <p><strong>Action:</strong> {qrData.action}</p>
                                {/* <p><strong>ID:</strong> {qrData.id}</p> */}
                                <p><strong>Name:</strong> {user.name}</p>
                                <p><strong>Email:</strong> {user.email}</p>
                                <p><strong>Phone:</strong> {user.phone}</p>
                                <p><strong>Role:</strong> {user.role}</p>
                            </div>
                        )}
                    </div>

                </div>)
            }
        </div >
    );
};

export default QrGeneration;
